import {Tax} from '../../models/Tax'
import Price from '../../models/Price'

export const calculatePrecioViaje = (precio: Price, tax: Tax): number => {
  return precio.price + precio.price * tax.value
}

export const isMaxToReserveReached = (
  passengersInCategory: number,
  maxToReserve: number | null
): boolean => {
  return maxToReserve !== null && passengersInCategory >= maxToReserve
}